import React, { useState } from "react";
import { Link } from "react-router-dom";

//Styles
import "./Header.scss";

//Components
import Button from "common-components/Button/Button";
import { ReactComponent as LogoSvg } from "assets/logo-header.svg";

function Header() {
  const [isMobileOpened, setIsMobileOpened] = useState(false);
  const menuItems = [
    { link: "1", text: "Categories" },
    { link: "2", text: "How it works" },
    { link: "3", text: "Browse contests" },
    { link: "4", text: "Prices" },
    { link: "5", text: "Testimonials" }
  ];
  return (
    <header className={"page-landing header" + (isMobileOpened ? " mobile-opened" : "")}>
      <div className="wrapper">
        <Link className="logo" to="/">
          <LogoSvg />
        </Link>
        <nav>
          <ul>
            {menuItems.map(({ link, text }) => (
              <li key={link}>
                <Link className="menu-link" to={link}>
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="actions">
          <Link className="menu-link" to="">
            Login
          </Link>
          <Button styleType="primary rounded">Get Started</Button>
        </div>
        <button
          className="mobile-menu-toggle"
          onClick={() => {
            setIsMobileOpened(!isMobileOpened);
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
